import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL

export const fetchBills = async (id) =>{
    try{
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.billing}/${URLEndpoints.orders}/${id}`)
        console.log(res.data.billingData)
        return res
    }catch (err){
        console.log("Data not Found",err)
    }   
}

export const createBill = async (data) =>{
    try{
        const res = await axios.post(`${BASE_URL}/${URLEndpoints.billing}/`,data)
        return res
    } catch (err){
        console.error('createBill failed', err?.response?.data || err)
        throw err
    }       
}

export const getSingleBill = async(id) =>{
    try{
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.billing}/${id}`)
        console.log(res.data.data,"SINGLEBILL???")
        return res.data.data
    }catch(err){
        console.log(err)
    }
}

export const updateBill = async(id,formData) =>{
    try{
        const res = await axios.put(`${BASE_URL}/${URLEndpoints.billing}/${id}`,formData)
        return res
    }catch (err){
        console.error('updateBill failed', err?.response?.data || err)
        throw err
    }   
}


export const deleteBill = async (id) => {
  try {
    const res = await axios.delete(
      `${BASE_URL}/${URLEndpoints.billing}/id/${id}`,
      { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return res;
  } catch (err) {
    console.error('deleteBill failed', err);
    throw err;
  }
};
export const createDraftBillFromPOs = async (payload) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/${URLEndpoints.billing}/from-pos`,
      payload,
      { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return res?.data;
  } catch (err) {
    console.error('createDraftBillFromPOs failed', err?.response?.data || err);
    throw err;
  }
};
